import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/store";

const LoginPage = () => {
  const navigate = useNavigate();
  const { login, authPrivateDataUrl } = useAuthStore();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  useEffect(() => {
    authPrivateDataUrl();
    const loggedInStatus = localStorage.getItem("isLoggedIn") === "true";
    console.log(loggedInStatus);
    setIsLoggedIn(loggedInStatus);

    if (loggedInStatus) {
      navigate("/dashboard"); // Redirect to dashboard if already logged in
    } else {
      authPrivateDataUrl();
    }
  }, [navigate]);

  if (isLoggedIn === null) {
    return null; // Prevent rendering until authentication status is determined
  }

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      const response = await login({
        email: formData.email,
        password: formData.password,
      });
      authPrivateDataUrl();
      const data = await response?.data;

      if (response?.err) throw new Error(response?.err || "Login failed");

      setSuccess("Login successful!");
      // Redirect user after successful login (replace with actual routing logic)
      setTimeout(() => {
        window.location.href = "/dashboard";
      }, 1000);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-4">
      <div className="w-full max-w-md bg-white rounded-3xl p-10 shadow-lg transform transition duration-500 hover:scale-105">
        <h2 className="text-4xl font-bold text-center mb-8 text-gray-800">
          Welcome Back
        </h2>
        {error && <p className="text-red-500 text-center">{error}</p>}
        {success && <p className="text-green-500 text-center">{success}</p>}
        <form className="space-y-6" onSubmit={handleSubmit}>
          {["email", "password"].map((field, idx) => (
            <input
              key={idx}
              type={field === "password" ? "password" : "email"}
              name={field}
              placeholder={field.replace(/([A-Z])/g, " $1").trim()}
              className="w-full px-5 py-3 border rounded-full focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
              value={formData[field]}
              onChange={handleChange}
            />
          ))}
          <button
            type="submit"
            className="w-full bg-indigo-500 hover:bg-indigo-600 text-white py-3 rounded-full shadow-lg transition duration-300"
          >
            Sign In
          </button>
        </form>
        <p className="text-center text-gray-600 mt-6">
          Don’t have an account?
          <span
            onClick={() => (window.location.href = "/create-account")}
            className="text-indigo-500 cursor-pointer ml-1 hover:underline"
          >
            Sign Up
          </span>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
